module.exports = __webpack_public_path__ + "static/AfterAproved-c67fe496829080ff72b03857e762634a.png";